import axios from "axios";
import get from 'lodash/get'
import format from 'date-fns/format'
import entities from 'src/config/entities'
import uniqWith from 'lodash/uniqWith'
let filterFieldsCache = {}

let filterMappings = {
  [entities.JOB]: (query) => {
    return [
      {
        field: "search",
        operator: "LIKE",
        value: query
      }
    ]
  },
  [entities.ORDER]: (query) => {
    return [
      {
        field: "search",
        operator: "LIKE",
        value: query
      }
    ]
  },
  default: (query) => []
}

function parseFilterValue(value) {
  if (value && value.getTime) {
    return format(value, 'yyyy-MM-dd')
  }
  return value
}

class SearchService {

  localSearchFunction (row, query, columns) {
    let found = false
    let queryLowerCase = query.toLowerCase()
    for (let column of columns) {
      let val = row[column.prop]
      let matches
      if (val !== undefined && typeof val === 'string') {
        matches = val.toLowerCase().includes(queryLowerCase)
      } else {
        if (val !== undefined && typeof val !== 'object') {
          matches = val.toString().includes(queryLowerCase)
        }
      }
      if (matches) {
        found = true
        break
      }
    }
    return found
  }

  localSearch (data, query, columns) {
    if (!query) {
      return data
    }
    return data.filter(row => {
      return this.localSearchFunction(row, query, columns)
    })
  }

  async searchData ({
                      page,
                      perPage,
                      data,
                      localData,
                      searchQuery,
                      columns,
                      service,
                      sort,
                      serviceMethod,
                      servicePath,
                      showPagination,
                      filterable,
                      filters,
                      tagFilters,
                      serviceParams,
                      entity
                    }) {
    let query = {}
    if (data.length > 0 || localData === true) {
      let tableData = this.localSearch(data, searchQuery, columns)
      return {
        tableData,
        total: tableData.length,
        params: {}
      }
    }
    if (!service) {
      return {
        tableData: data,
        total: data.length,
        params: {}
      }
    }
    let params = {
      page: page,
      limit: perPage,
      ...serviceParams
    }
    let localSort
    if (searchQuery) {
      params.query = searchQuery
    }
    filters.forEach(({key, value}) => {
      params[key] = value
    })

    if (sort) {
      params.sort = sort
    } else if (params.sort) {
      localSort = params.sort
    }
    if (!showPagination) {
      delete params.page
      delete params.limit
    }

    let response, filterFieldsResponse = {}
    if (filterable) {
      query = this.buildSearchQuery({
        filters: tagFilters,
        queryFilters: filters,
        sort,
        page,
        perPage
      })
      if (searchQuery) {
        let searchQueryFilters = filterMappings[entity] || filterMappings.default
        query.filters = query.filters.concat(searchQueryFilters(searchQuery))
        query = this.removeQueryDuplicates(query)
      }
      response = await axios.post(`/${service.entityPath}/filter`, query)
      if (filterFieldsCache[service.entityPath]) {
        filterFieldsResponse = filterFieldsCache[service.entityPath]
      } else {
        filterFieldsResponse = await axios.get(`/${service.entityPath}/filter-fields`)
        filterFieldsCache[service.entityPath] = filterFieldsResponse
      }
    } else {
      response = await service[serviceMethod](params, servicePath)
    }
    let tableData = response.data.data ? response.data.data : response.data
    let totalFromPagination = get(response, 'data.pagination.total', 0)
    let total = response.total || totalFromPagination
    let filterFields = {}
    if (filterFieldsResponse.data) {
      filterFields = filterFieldsResponse.data
    }
    return {
      params,
      sort: localSort,
      tableData,
      filterFields,
      total,
      query
    }
  }

  buildSearchQuery ({ filters, queryFilters, sort, page, perPage}) {
    // TODO add `with` query support
    let query = {
      filters: [],
      sort: {
        page: page || 1,
        limit: perPage || 10
      }
    }
    if (sort) {
      let order = sort.charAt(0) === '-' ? 'desc' : 'asc'
      let sortKey = sort.substring(1)
      query.sort.order = {
        [sortKey]: order
      }
    }
    query.filters = filters.map(f => {
      let value = f.values, min, max
      if(f.field.type === 'integer') {
        value = parseInt(f.values)
      }
      value = parseFilterValue(value)

      if (f.operator === '><') {
        min = parseFilterValue(f.min)
        max = parseFilterValue(f.max)
      }

      return {
        field: f.field.field,
        operator: f.operator,
        value,
        min,
        max
      }
    })
    queryFilters.forEach(filter => {
      if (filter.key === 'with') {
        query.withs = filter.value.split(',');
      } else if (filter.operator && filter.value) {
        query.filters.push(filter)
      } else if (filter.key.startsWith('match')) {
        const parts = filter.key.split('match')
        const field = parts[parts.length - 1]
          .replace('[', '')
          .replace(']', '')
        const value = filter.value
          query.filters.push({
            field,
            operator: 'IS',
            value
          })
      }
    })
    return query
  }

  removeQueryDuplicates(query) {
    query.filters = uniqWith(query.filters, (a, b) => {
      return a.field === b.field && a.operator === b.operator
    })
    return query
  }
}

export default new SearchService
